<template>
  <div class="text-pages d-flex flex-grow-1 flex-wrap" data-testid="text-pages">
    <div
      v-if="document.text_by_page"
      class="d-flex mx-auto flex-column justify-content-center align-items-center"
    >
      <div
        v-for="page in document.text_by_page"
        :key="page.page_number"
        class="i-p-3 w-100"
      >
        <div class="text-center w-100">
          <span>Page {{ page.page_number }} / {{ document.total_pages }}</span>
        </div>
        <div class="card i-p-3 i-mt-3 fs-exclude">
          <pre>{{ page.text }}</pre>
        </div>
      </div>
    </div>
    <div v-else class="d-flex w-100 align-items-center justify-content-center">
      <i-spinner></i-spinner>
    </div>
  </div>
</template>

<script>
import { iSpinner } from '@inscribe/signal';

export default {
  components: { iSpinner },
  props: {
    document: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.text-pages {
  position: relative;
  margin: auto;
  overflow: auto;
  max-height: 100%;
  font-size: $font-size-small;
}
</style>
